import styled from "styled-components";

export const Wrapper = styled.div`
  position: absolute;
  height: 100%;
  background: #fff;
  background: ${(props) => props.purple && "#402680"};
  background: ${(props) => props.darkPurple && "#3B045D"};
  background: ${(props) => props.white && "#fff"};
  background: ${(props) => props.grey && "#d0d0d0"};
  width: 100%;
  left: 0;
  top: 0;
  z-index: 4;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1.7em;
  font-size: ${(props) => props.smallFont && "1.2em"};
  font-size: ${(props) => props.mediumFont && "1.5em"};
  color: ${(props) => props.purple && "#fff"};
  color: ${(props) => props.darkPurple && "#fff"};
  color: ${(props) => props.white && "#565656"};
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => (props.noText ? "center" : "space-between")};
  height: 95px;
`;

export const Text = styled.div`
  display: flex;
`;

export const Spinner = styled.img`
  width: 40px;
  width: ${(props) => props.smallFont && "25px"};
  width: ${(props) => props.mediumFont && "35px"};
  height: 40px;
  height: ${(props) => props.smallFont && "25px"};
  height: ${(props) => props.mediumFont && "35px"};
  align-self: center;
`;
